import { type PopupProps, Popup } from '@CS/components/Popups';
import { useNavigateQuery } from '@/hooks';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Lose.module.css';
import Content from './content';

export const Lose = (props: PopupProps) => {
  const navigate = useNavigateQuery();
  const onClick = () => navigate('/');
  const { title, description, ok } = useTranslation(Content);

  return (
    <Popup
      hideClose
      {...props}
      opacity="0"
      className={CSS.loseContainer}
    >
      <div className={CSS.loseContent}>
        <h4>{title}</h4>
        <span>{description}</span>
        <Button text={ok} onClick={onClick} />
      </div>
    </Popup>
  );
};
